<template lang="pug">
.t-content
  #modal-checkinclaim.modal.fade(tabindex='-1' aria-hidden='true')
    .modal-dialog.modal-dialog-centered.modal-fullscreen
      .ci-cmsg-wrapper
        .ci-cmsgbox
          .bbg
            img(src='assets/img/checkin/pop.png')
          .ccon
            .ttext You've hit the deposit milestone & earned a free bonus in your inbox.
              br
              | Enjoy the extra fun!
            .bclose(data-bs-dismiss='modal' aria-label='Close' @click="toInbox") CLOSE
  section.info-sec
    .max-container
  
      .checkin-wrapper
        .checkinbox
          .ttitle
            img(src='assets/img/check-in/title.png')
          //- .subtitle Deposit & Earn MYR 300
          .ci-wrapper(:class="{'mt-1': dataDay.length > 0}")
            template(v-for="(data, index) in dataDay")
              .cib(v-if="index < 4" :class="[{'claimed' : data.claimed===true}, {'ready' : data.ready === true}]" @click="triggerAction(data.ready, data.claimed)")
                .ci-date(v-if="data.claimed")
                  span {{ data.date }}
                .bbg
                  img(v-if="data.claimed || data.ready" src='assets/img/check-in/unlock.png')
                  img(v-else src='assets/img/check-in/lock.png')
                .tt {{data.day}}
                //- .amount(v-if="data.claimed && index < 4") MYR 2
                //- .amount(v-if="data.claimed && index < 4") {{ data.date }}
                .iimg
                  img(:src="'assets/img/checkin/c'+(index+1)+'.png'")
          .ci-extra 
            .til {{dataDay[4].day}}
              template(v-if="dataDay[4].claimed")
                br
                span {{dataDay[4].date}}
            .checked(v-if="dataDay[4].claimed")
              img(src="assets/img/check-in/checked.png")
            .cibfs
              .cib 
                .bbg 
                  img(src="assets/img/check-in/unlock.png")
              i.fa-solid.fa-plus
              .bbg
                img(src="assets/img/check-in/freespin-tb.png")
            .depo.pointer(@click="triggerAction(dataDay[4].ready, dataDay[4].claimed)")
              img(src="assets/img/check-in/deposit.png")
          //- .ci-wrapper
            .cib.claimed
              .bbg
                img(src='assets/img/checkin/base.png')
              .tt Day 1
              .iimg
                img(src='assets/img/checkin/c1.png')
            .cib.ready
              .bbg
                img(src='assets/img/checkin/base.png')
              .tt Day 2
              .iimg
                img(src='assets/img/checkin/c2.png')
            .cib
              .bbg
                img(src='assets/img/checkin/base.png')
              .tt Day 3
              .iimg
                img(src='assets/img/checkin/c3.png')
            .cib
              .bbg
                img(src='assets/img/checkin/base.png')
              .tt Day 4
              .iimg
                img(src='assets/img/checkin/c4.png')
            .cib
              .bbg
                img(src='assets/img/checkin/base.png')
              .tt Day 5
              .iimg
                img(src='assets/img/checkin/c5.png')
          .ci-pbar(v-if="isLoggedIn")
            .ccon
              .iimg
                img(src='assets/img/check-in/wallet.png')
              .progress
                .progress-bar.progress-bar-striped.progress-bar-animated(role="progressbar" :aria-valuenow="depoProgress" aria-valuemin="0" aria-valuemax="100" :style="'width:'+depoProgress+'%'")
                //- span.bars(:style="'width:'+depoProgress+'%'")
                span MYR{{$numeral(depoAmount).format("0,0.00")}} / MYR6000.00
          .ci-pbar.s2.done2(v-if="isLoggedIn")
            .ccon
              .iimg
                img(src='assets/img/check-in/free.png')
              .progress
                .progress-bar.progress-bar-striped.progress-bar-animated(role="progressbar" :aria-valuenow="accuProgress" aria-valuemin="0" aria-valuemax="100" :style="'width:'+accuProgress+'%'")
              //- .pgbar
                .tipsbtn(v-if="accuProgress > 0 && dayComplete === 5" :class="{'f-bar': accuProgress === 100}" :style="'left:calc('+accuProgress+'% - 39px)'")
                  a(href='javascript:void(0);' @click="missionClaim")
                    img(src='assets/img/check-in/claim.png' style="width: 78px !important")
                span.bars(:class="{'c-radius' : accuProgress === 100}" :style="'width:'+accuProgress+'%'") 
              .rw
                div(:class="{'text-white': accuProgress >= 100/6}") MYR10
                div(:class="{'text-white': accuProgress >= 100/6*2}") MYR20
                div(:class="{'text-white': accuProgress >= 100/6*3}") MYR50
                div(:class="{'text-white': accuProgress >= 100/6*4}") MYR70
                div(:class="{'text-white': accuProgress >= 100/6*5}") MYR150
                div(:class="{'text-white': accuProgress === 100}") MYR300
              .tipsbtn.text-center(v-if="accuProgress > 0 && dayComplete === 5")
                a(href='javascript:void(0);' @click="missionClaim")
                  img(src='assets/img/checkin/claim.png')
          template(v-if="getLanguage === 'my'")
            .table-responsive.ci-table
              table.table-history.text-center.v2
                thead
                  tr
                    th Attendance
                    th Deposit Terkumpul
                    th Bonus
                    th Extra
                tbody
                  tr
                    td(rowspan="6") Depo & Daftar Masuk dalam Mana-mana 5 Hari Dalam Tempoh 30 Hari
                    td MYR 150 dan ke atas
                    td MYR 10.00
                    td(rowspan="6")
                      img(src="assets/img/check-in/freespin.png")
                  tr
                    td MYR 300 dan ke atas
                    td MYR 20.00
                  tr
                    td MYR 1000 dan ke atas
                    td MYR 50.00
                  tr
                    td MYR 1500 dan ke atas
                    td MYR 70.00
                  tr
                    td MYR 3000 dan ke atas
                    td MYR 150.00
                  tr
                    td MYR MYR 6000 dan ke atas
                    td MYR 300.00
            .ci-tnc-wrapper
              b TERMA & SYARAT
              ul
                li Untuk menuntut bonus ini, pemain mesti membuat deposit terkumpul sekurang-kurangnya RM150 dalam mana-mana 5 hari dalam tempoh 30 hari.
                li Bonus akhir akan merujuk kepada jadual bonus.
                li Selepas mengumpul bonus ini, sila hubungi Live Chat kami untuk menuntut 10X Putaran Percuma.
                li Jumlah pengeluaran maksimum untuk promosi ini hanya boleh dilakukan sekali dan dihadkan kepada 5x (jumlah bonus).
                li Baki kredit yang tinggal selepas pengeluaran akan dikeluarkan daripada akaun pemain.
                li
                  b.text-danger Bonus ini tidak boleh dituntut bersama dengan deposit dan promosi lain kecuali dinyatakan sebaliknya.
                li Untuk semua slot game
              b TERMA & SYARAT AM
              ul
                li Pengeluaran terhad kepada 5 kali sehari sahaja.
                li EpicWin memiliki hak untuk menamatkan akaun ahli tanpa notis awal jika berlaku pelanggaran terma & syarat
                li Jumlah pengeluaran minimum adalah MYR 10
          template(v-else-if="getLanguage === 'zh'")
            .table-responsive.ci-table
              table.table-history.text-center.v2
                thead
                  tr
                    th 出席率
                    th 累计存款金额
                    th 奖金金额
                    th 额外
                tbody
                  tr
                    td(rowspan="6") 在30天内任意5天存款并签到
                    td 150 令吉或以上
                    td MYR 10.00
                    td(rowspan="6")
                      img(src="assets/img/check-in/freespin.png")
                  tr
                    td 300 令吉或以上
                    td MYR 20.00
                  tr
                    td 1000 令吉或以上
                    td MYR 50.00
                  tr
                    td 1500 令吉或以上
                    td MYR 70.00
                  tr
                    td 3000 令吉或以上
                    td MYR 150.00
                  tr
                    td 6000 令吉或以上
                    td MYR 300.00
            .ci-tnc-wrapper
              b 规则与条件
              ul
                li 要领取此奖金，玩家必须在30天内的任意5天累计存款至少RM150。
                li 最终奖金将根据奖金表进行分配。
                li 领取此奖金后，请联系客服以获取10次免费旋转。
                li 本次促销的最大提款金额只能进行一次，最低和最高为奖金金额的5倍。
                li 提款后的任何剩余余额将从玩家账户中移除。
                li
                  b.text-danger 此优惠不能与其他存款和促销同时领取，除非另有说明。
                li 可用于所有老虎机游戏。
              b 常规规则与条件
              ul
                li 每日提款次数限制为5次
                li Epicwin保留冻结会员账户的拥有权，若是违反条规，将不会另行通知
                li 最低提款金额为 MYR 10
          template(v-else)
            .table-responsive.ci-table
              table.table-history.text-center.v2
                thead
                  tr
                    th Attendance
                    th Accumulated Deposit
                    th Bonus
                    th Extra
                tbody
                  tr
                    td(rowspan="6") Accumulate any 5 days
                    td MYR 150 and above
                    td MYR 10.00
                    td(rowspan="6")
                      img(src="assets/img/check-in/freespin.png")
                  tr
                    td MYR 300 and above
                    td MYR 20.00
                  tr
                    td MYR 1000 and above
                    td MYR 50.00
                  tr
                    td MYR 1500 and above
                    td MYR 70.00
                  tr
                    td MYR 3000 and above
                    td MYR 150.00
                  tr
                    td MYR 6000 and above
                    td MYR 300.00
            .ci-tnc-wrapper
              b TERMS AND CONDITIONS
              ul
                li To claim this bonus, player must make accumulated deposit of at least min RM150 on ANY 5 days within 30 days.
                li The final bonus will refer to the bonus table
                li After collect this bonus, please contact our Live Chat to claim 10X Free Spin. 
                li Maximum withdrawal amount for this promotion can only be done once for a min & maximum of 5x (bonus amount)
                li Any remaining credit balance after withdrawal will be removed from player's account
                li 
                  b.text-danger This bonus cannot be claimed in conjunction with other deposit & promotions unless otherwise specified
                li Can Play All Slots
              b GENERAL TERMS & CONDITIONS
              ul
                li Withdrawal is limited to 5 times per day.
                li EpicWin reserves all rights to terminate members' accounts in case of T&C violations without prior notice
                li Minimum withdrawal amount is RM10 
</template>
<script>
export default {
  data(){
    return{
      dataDay:[
        {day: "Day 1", claimed: "", ready: "",},
        {day: "Day 2", claimed: "", ready: "",},
        {day: "Day 3", claimed: "", ready: "",},
        {day: "Day 4", claimed: "", ready: "",},
        {day: "Day 5", claimed: "", ready: "",},
      ],
      depoAmount: "",
      targetAmount: 6000.00,
      depoProgress: "",
      accuProgress: "",
      dayComplete:0,
      feedback: {
        success: true,
        status: ""
      },
      metaData: []
    }
  },
  // metaInfo(){
  //   if(this.metaData.length> 0){
  //     return{
  //       title: this.metaData[0].meta_title || 'EpicWin Malaysia',
  //       meta:[
  //         { name: 'description',content: this.metaData[0].meta_desc },
  //         { name: "keywords", content: this.metaData[0].meta_keywords },
  //         { name: "author", content: this.metaData[0].meta_author },
  //         { name: "publisher", content: this.metaData[0].meta_publisher },

  //         { property: 'og:title', content: this.metaData[0].meta_title },
  //         { property: 'og:description', content: this.metaData[0].meta_desc },
          
  //       ],
  //       link: [
  //         { rel: 'canonical', href: this.metaData[0].meta_canonical }, // Sets the canonical URL
  //       ],
  //     }
  //   }else{
  //     return{
  //       title: 'EpicWin Malaysia',
  //       meta:[
  //         { name: 'description',content: 'EpicWin Malaysia' },
  //       ],
  //     }
  //   }
  // },
  computed:{
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getLanguage() {
      return this.$store.getters.language || "en"
    },
  },
  watch:{
    sessionToken(newState, oldState){
      if(newState === '' || newState === undefined){
        this.dataDay = [
          {day: "Day 1", claimed: "", ready: "", date:""},
          {day: "Day 2", claimed: "", ready: "", date:""},
          {day: "Day 3", claimed: "", ready: "", date:""},
          {day: "Day 4", claimed: "", ready: "", date:""},
          {day: "Day 5", claimed: "", ready: "", date:""},
        ]
        this.depoAmount = ""
      }else{
        this.missionDetails()
      }
    }
  },
  created(){
    // $('link[rel="canonical"]').attr('href', 'https://www.epicwin.app/missions');
  },
  mounted(){
    if(this.isLoggedIn){
      this.missionDetails()
    }
    // this.getSeo()
    window.scroll(0,0)
  },
  methods:{
    getSeo(){			
      var temp = window.location.pathname.split("/")
      let page_name = temp[temp.length-1]
      let domain_name = window.location.hostname
			this.$store
				.dispatch("user/getSeo", {page_name, domain_name})
				.then(response => {
					this.loading = false;
					this.feedback.success = response.success
					if (this.feedback.success == true) {
						if(response.data.length > 0){
							// this.$store.dispatch("user/seoInfo", response.data[0])
              this.metaData = response.data
						}
					} else {
						if((typeof response.status) != 'object'){
							this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
						}       
					}
				})
				.catch(response => {
					this.loading = false;
					var vm = this;
					if((typeof response.status) != 'object'){
						this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
					}
				});
		},
    toInbox(){
      this.$router.push({
        name:"profile",
        params:{
          "inbox": true
        }
      }).catch(error =>{})
    },
    triggerAction(target, filter){
      if(!this.isLoggedIn){
        this.$helpers.openModal("#modal-login")
      }
      if(target === true || target === ""){
        if(filter !== true){
          this.$router.push("deposit").catch(error =>{})
        }
        
      }
    },
    missionDetails(){
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/missionDetails", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {  
              this.dayComplete = response.data.length
              if(response.data.length > 0){
                var latestDate = this.$moment(response.data[this.dayComplete-1].deposit_date).format("YYYY-MM-DD")
                var currentDate = this.$moment(new Date()).format("YYYY-MM-DD")
                for(let i = 0; i < this.dayComplete; i++){
                  if(this.depoAmount === ''){
                    this.depoAmount = response.data[i].deposit_amount
                  }else{
                    this.depoAmount = this.depoAmount + response.data[i].deposit_amount
                  }
                  this.dataDay[i].claimed = true
                  this.dataDay[i].date = this.$moment(response.data[i].deposit_date).format("MM/DD")
                  if(latestDate !== currentDate){
                    if(latestDate.localeCompare(currentDate) === -1 && (this.dayComplete-i === 1)){
                      if(i+1 < 5){
                        this.dataDay[i+1].ready=true
                      } 
                    }
                  }
                }
                this.depoProgress = parseFloat(this.depoAmount) / this.targetAmount * 100
                if(this.depoAmount >= 150 && this.depoAmount < 300){
                  this.accuProgress = 100/6
                }else if(this.depoAmount >= 300 && this.depoAmount < 1000){
                  this.accuProgress = 100/6*2
                }else if(this.depoAmount >= 1000 && this.depoAmount < 1500){
                  this.accuProgress = 100/6*3
                }else if(this.depoAmount >= 1500 && this.depoAmount < 3000){
                  this.accuProgress = 100/6*4
                }else if(this.depoAmount >= 3000 && this.depoAmount < 6000){
                  this.accuProgress = 100/6*5
                }else if(this.depoAmount >= 6000){
                  this.accuProgress = 100
                }else{
                  this.accuProgress = 0
                }
              }else{
                this.dataDay[0].ready = true
              }
              
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }              
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }  
          });
      }
    },
    missionClaim(){ 
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/missionClaim", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              // $("#modal-checkinclaim").modal("show")
              this.toInbox()
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }              
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }  
          });
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.c-radius{
  border-radius: 20px !important;
}
.f-bar{
  left: calc(100% - 78px) !important
}
.cib .amount{
  text-transform: uppercase;
  font-weight: bold;
  font-size: 14px;
  color: #FFC000;
  position: absolute;
  width: 100%;
  text-align: center;
  top: -28px;
  z-index: 1;
  line-height: normal;
  @media(min-width: 681px) {
    font-size: 18px;
    top: -35px;
  }
}
</style>